import React, { useEffect, useState } from "react";
import "./Branding_How_it_Works.css";
import Branding_How_it_Works_card from "../../../Common_Component/Branding_How_it_Works_card/Branding_How_it_Works_card";
import { useParams } from "react-router-dom";

function Branding_How_it_Works() {
  const [brandHowWorksData, setBrandHowWorksData] = useState([]);
  const { id } = useParams();

  const data = [
    {
      id: 1,
      imgSrc: "/Assets/Images/Service/Services_inner/Logo_Design/LOGO_Designing.png",
      brandHowWorks: [
        {
          title: "Understanding Your Brand",
          title2: "",
          descn:
            "We begin by learning about your business, values, target audience, and design preferences.",
        },
        {
          title: "Concept Development",
          title2: "",
          descn:
            "Our team brainstorms and creates multiple design concepts that align with your brand identity.",
        },
        {
          title: "Refining the Design",
          title2: "",
          descn:
            "Based on your feedback, we refine and tweak the designs to ensure they meet your expectations.",
        },
        {
          title: "Final Delivery",
          title2: "",
          descn:
            "Once the design is approved, we provide you with high-quality logo files in multiple formats for various use cases (web, print, merchandise, etc.).",
        },
      ],
    },
    {
      id: 2,
      imgSrc: "/Assets/Images/Service/Services_inner/Graphic_Designing/Graphic-Designing.png",
      brandHowWorks: [
        {
          title: "Understanding Your Needs",
          title2: "",
          descn:
            "We collaborate with you to understand your goals, target audience, and design preferences.",
        },
        {
          title: "Concept Creation",
          title2: "",
          descn:
            "Our team develops multiple design concepts tailored to your requirements.",
        },
        {
          title: "Feedback and Revisions",
          title2: "",
          descn:
            "We refine the designs based on your feedback to ensure they align with your vision.",
        },
        {
          title: "Final Delivery",
          title2: "",
          descn:
            "Receive polished, high-quality graphics in formats suitable for various platforms and applications.",
        },
      ],
    },
    {
      id: 3,
      imgSrc: "/Assets/Images/Service/Services_inner/Brand_Design/Brand-Design.png",
      brandHowWorks: [
        {
          title: "Brand Discovery",
          title2: "",
          descn:
            "We dive deep into understanding your business, target audience, competition, and brand vision.",
        },
        {
          title: "Concept Development",
          title2: "",
          descn:
            "Develop a creative strategy that includes logo concepts, colour palettes, typography, and other design elements.",
        },
        {
          title: "Feedback and Refinement",
          title2: "",
          descn:
            "Work closely with you to refine the designs, ensuring they align perfectly with your brand identity.",
        },
        {
          title: "Asset Creation",
          title2: "",
          descn:
            "Deliver a complete suite of branding assets, ready to be used across all touchpoints.",
        },
        {
          title: "Brand Guidelines",
          title2: "",
          descn:
            "Provide a detailed brand style guide to maintain consistency across all platforms and materials.",
        },
      ],
    },
  ];

  useEffect(() => {
    const filteredData = data.filter((item) => item.id === Number(id));
    setBrandHowWorksData(filteredData);
  }, [id]);

  return (
    <section className="Branding_How_it_Works">
      <div className="container">
        <div className="row justify-content-center">
          {brandHowWorksData.length > 0 && (
            <>
              <div className="col-xl-4 col-lg-4 col-md-6 col-6">
                <div className="main_img_holder">
                  <img
                    className="Branding_How_it_Works_img"
                    src={process.env.PUBLIC_URL + brandHowWorksData[0]?.imgSrc}
                    alt="Branding_How_it_Works_img"
                  />
                </div>
              </div>

              <div className="col-xl-8 col-lg-12 col-md-10 col-10">
                <div className="heading_holder">
                  <h5>How it Works</h5>
                </div>
                <div className="main_content_card_holder">
                  {brandHowWorksData[0]?.brandHowWorks?.map((item, index) => (
                    <div className="content_card_holder" key={index}>
                      <Branding_How_it_Works_card
                        title={item?.title}
                        title2={item?.title2}
                        descn={item?.descn}
                        index={index + 1}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default Branding_How_it_Works;
